import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="bg-softRose min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-pinkAccent opacity-50 select-none">
            404
          </h1>
        </div>

        {/* Error Message */}
        <div className="space-y-4">
          <h2 className="text-3xl font-bold text-gray-900">
            Oops! Page Not Found
          </h2>
          <p className="text-lg text-slateText max-w-sm mx-auto">
            The page you're looking for doesn't exist or has been moved to a different location.
          </p>
        </div>

        {/* Illustration/Icon */}
        <div className="py-8">
          <div className="w-24 h-24 mx-auto bg-pinkAccent bg-opacity-20 rounded-full flex items-center justify-center">
            <svg 
              className="w-12 h-12 text-pinkAccent" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
              />
            </svg>
          </div>
        </div>

        {/* Action Links */}
        <div className="space-y-4">
          <Link
            to="/"
            className="block w-full px-6 py-3 text-center text-base font-medium text-white bg-pinkAccent border border-transparent rounded-lg hover:bg-pink-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pinkAccent transition-colors duration-200"
          >
            Back to Home
          </Link>
          
          <Link
            to="/"
            className="block w-full px-6 py-3 text-center text-base font-medium text-pinkAccent bg-white border border-pinkAccent rounded-lg hover:bg-softRose focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pinkAccent transition-colors duration-200"
          >
            Browse Products
          </Link>
        </div>

        {/* Additional Help */}
        <div className="pt-8 border-t border-lightGray">
          <p className="text-sm text-slateText">
            Need help? {' '}
            <Link 
              to="/contact" 
              className="text-pinkAccent hover:text-pink-700 font-medium underline"
            >
              Contact Support
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;